<div class="cv-tab-group cv-tabs-component">
  <ul class="nav nav-tabs cv-tab-group__tab-container">
    <li class="nav-item cv-tab-group__tab action-select"
      *ngFor="let tab of tabs"
      (click)="setActiveTab(tab)"
    >
      <a href="javascript:void(0)" 
        cvTooltip 
        [disabled]="!tab.tooltip" 
        [tooltipText]="tab.tooltip" 
        [centered]="true"
        [ngClass]="{
          'cv-tab-label': true,
          'cv-tab-active cv-tab-group--tab-active': tab.active
        }">
        <i class="fas fal far fad {{ tab.icon }}" *ngIf="tab.icon"></i>
        <span class="item-value">{{ tab.title }}</span>
      </a>
    </li>
  </ul>
  <ng-content></ng-content>
</div>
